interface AuthHeadingProps {
	title: string;
	subtitle?: string;
}

const AuthHeading = ({ title, subtitle }: AuthHeadingProps) => (
	<div className="tw-mb-6">
		<h1 className="tw-mb-1 tw-text-[24px] tw-font-bold tw-text-text">{title}</h1>
		{subtitle && <p className="tw-text-[13.5px] tw-text-text-soft">{subtitle}</p>}
	</div>
);

export default AuthHeading;
